import { render, staticRenderFns } from "./complementaryEnrichment.vue?vue&type=template&id=f290a76c&scoped=true"
import script from "./complementaryEnrichment.vue?vue&type=script&lang=js"
export * from "./complementaryEnrichment.vue?vue&type=script&lang=js"
import style0 from "./complementaryEnrichment.vue?vue&type=style&index=0&id=f290a76c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f290a76c",
  null
  
)

export default component.exports